import { Dispatch, Action, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import {
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  GET_DATA_USER_LOGIN_AUTH,
  LoginUserRequestAction,
  LoginUserSuccessAction,
  LoginUserFailureAction,
  VALIDATE_TOKEN_SUCCESS,
  VALIDATE_TOKEN_FAILURE,
  VALIDATE_TOKEN_REQUEST,
  VALIDATE_USER_AUTH
} from '../../../../constants/auth/login/Login';
import { RootState } from '../../../store/store';
import fetchWithIP from '../../utils/FechHeaders';

export const loginUserRequest = (): LoginUserRequestAction => ({
  type: LOGIN_USER_REQUEST
});

export const loginUserSuccess = (data: any): LoginUserSuccessAction => ({
  type: LOGIN_USER_SUCCESS,
  payload: data
});

export const loginUserFailure = (error: string): LoginUserFailureAction => ({
  type: LOGIN_USER_FAILURE,
  payload: error
});

export const loginUser = (
  values: {
    email: string,
    contrasena: string
  }): ThunkAction<
    Promise<any>,
    RootState,
    unknown,
    AnyAction
  > => async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(loginUserRequest());

    try {
      const response = await fetchWithIP(
        'auth/login',
        {
          method: 'POST'
        },
        values
      );

      const data = await response.json();

      if (!response.ok) {
        dispatch(loginUserFailure(data.message || 'Error al iniciar sesión'));
        localStorage.clear();
        return { respuesta: false };
      }

      if (data.respuesta) {
        dispatch({
          type: GET_DATA_USER_LOGIN_AUTH,
          payload: { ...data.user }
        });
        
        localStorage.setItem('token', data.token);
      }

      dispatch(ValidateTokenAuthReducer())
      dispatch(loginUserSuccess(data));
      return data;

    } catch (error: any) {
      console.error('Error al iniciar sesión', error);
      dispatch(loginUserFailure(error.message || 'Error desconocido al iniciar sesión'));
      localStorage.clear();
      return { respuesta: false };
    }
  };

  export const ValidateTokenAuthReducer = (
    token?: string
  ): ThunkAction<
    Promise<any>,
    RootState,
    unknown,
    Action<string>
  > => async (dispatch: Dispatch) => {
    dispatch({
      type: VALIDATE_TOKEN_REQUEST
    });
  
    try {
      dispatch({
        type: VALIDATE_USER_AUTH,
        payload: false
      });
  
      const response = await fetchWithIP(
        'auth/validateToken',
        {
          method: 'POST'
        },
        {
          token: token ? token : localStorage.getItem('token')
        }
      );
  
      const data = await response.json();
  
      if (data.respuesta) {
        dispatch({
          type: GET_DATA_USER_LOGIN_AUTH,
          payload: data.data.user,
        });
        localStorage.setItem('token', data.data.token);
        dispatch({
          type: VALIDATE_TOKEN_SUCCESS,
          payload: data
        });
      } else {
        localStorage.clear();
        dispatch({
          type: VALIDATE_TOKEN_FAILURE,
          payload: data.message || 'Error al validar el token'
        });
      }
  
      return data;
  
    } catch (error: any) {
      console.error('Error al validar el token', error);
      localStorage.clear();
      dispatch({
        type: VALIDATE_TOKEN_FAILURE,
        payload: error.message || 'Error desconocido al validar el token'
      });
      throw error;
    }
  };